import * as React from "react";
import { observer } from "mobx-react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
  Button,
  Tooltip,
} from "@material-ui/core";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import * as _ from "lodash";
import imgFilter from "common/assets/images/filter.svg";
import imgFilterOutline from "common/assets/images/filterOutline.svg";
import { WBSStore } from "modules/WBS/WBSStore";
import i18n from "i18n";
import { List, Grid, ScrollSync } from "react-virtualized";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { ERightMenuTab } from "common/enums";
import { CompareBlack } from "common/icons";
import { formatNumber } from "utils/MathUtils";
import { toJS } from "mobx";

const styles: any = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 200px)",
  },
  box: { display: "flex", flexDirection: "row" },
  leftSide: {
    position: "absolute" as any,
    top: 0,
    left: 0,
    zIndex: 99,
    borderRight: "solid 1px #e0e0e0",
  },
  topSelect: {
    width: "30px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#FFF",
  },
  listContainer: { position: "absolute" as any, top: 0, left: 0 },
  headerContainer: {
    fontFamily: "Roboto",
  },
  header: {
    fontSize: "12px",
    color: "#5c5c5c",
    "& th": {
      height: "50px",
      padding: "0px 0px",
      border: "0px",
    },
  },
  headerRoot: {
    height: "50px",
    position: "absolute",
    "& > :last-child": {
      padding: "0px",
      borderRight: "0",
    },
  },
  cellWrapper: {
    cursor: "pointer",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#EDF2CB",
      "& > img": {
        opacity: 1,
      },
    },
    position: "sticky" as any,
    top: "0px",
    background: "white",
    zIndex: 10 as any,
  },
  cellText: {
    overflow: "hidden",
    whiteSpace: "nowrap" as any,
    textOverflow: "ellipsis",
    display: "block",
  },
  buttonContainer: { display: "flex", justifyContent: "center" },
  button: {
    height: "36px",
    width: "256px",
    marginTop: 25,
    marginBottom: 25,
    padding: 0,
    background: "#ABC200",
    "&:hover": {
      background: "#92A501",
    },
  },

  cellRoot: {
    padding: "0px",
    borderRight: "1px solid #e0e0e0",
    background: "#f5f5f5",
  },

  thLink: {
    width: "25px",
  },
  tableBody: {
    fontSize: "13px",
    color: "#666",
    "& > :first-child": {
      borderTop: "1px solid #e0e0e0",
    },
  },
  linkIcon: {
    fontSize: "15px",
    color: "#5c5c5c",
    display: "block",
    margin: "auto",
  },
  input: {
    outlineStyle: "none" as any,
    paddingRight: "10px",
    fontSize: "13px",
    color: "#666",
    height: "24px",
    border: "0",
    backgroundColor: "unset",
    position: "relative" as any,
  },
  cellDisabled: {
    display: "flex",
    alignItems: "center",
  },
  link: {
    display: "flex",
    paddingRight: "10px",
    fontSize: "13px",
  },
  imgFilter: {
    paddingLeft: "10px",
  },

  imgFilterOpacity: {
    paddingLeft: "10px",
    opacity: 1,
    transition: "all 0.3s ease-in",
    display: "inline-block",
  },
  imgHidden: {
    display: "none",
  },

  column: {
    borderLeft: "1px solid #e0e0e0",
    borderBottom: "1px solid #e0e0e0",
    padding: "4px 8px",
    textAlign: "end",
  },
  columnEmpty: {
    padding: "4px 8px",
  },
  listCheckbox: { padding: "0", color: "#666666!important" },
});

type IProps = {
  classes: any;
};

type IState = {
  columnsSize: Array<number>;
  list: Array<Array<string>>;
  empty: boolean;
  selectedColumnId: number;
  columns: Array<any>;
};

@observer
class TakeOffTable extends React.Component<IProps, IState> {
  state: IState = {
    columnsSize: [],
    // Grid data as an array of arrays
    list: [[]],
    empty: false,
    selectedColumnId: -1,
    columns: [],
  };

  componentWillReceiveProps(nextProps) {
    this.createTableStructure(false); // Atualiza depois do filtro
  }

  componentWillMount() {
    this.createTableStructure();
  }

  componentDidMount() {
    ModelMapStore.takeOffEditCompare = _.cloneDeep(
      ModelMapStore.modelMapFormat
    );
  }

  createTableStructure(resize = true) {
    const tableGrid: string[][] = [];
    const sizesList: number[] = [];

    const columns = TakeOffStore.takeOffColumns.sort(); // Ordena as colunas
    let empty = false;

    // Obter dados das linhas filtradas
    TakeOffStore.takeOffFilteredItems.forEach((line) => {
      const tableLine: string[] = [];
      const lineMaterials = Object.keys(line.materials);
      let index: number = 0;

      columns.forEach((clmn) => {
        if (clmn === "Contador") return;

        let isMaterial = lineMaterials.indexOf(clmn) !== -1;
        let text = getColumn(clmn, line.properties[clmn], isMaterial);

        if (resize) {
          addColumnsSizeItem(index, clmn.length, text.length);
        }

        tableLine.push(text);
        index++;
      });

      tableGrid.push(tableLine);
    });

    // Se tabela estiver vazia
    if (tableGrid.length === 0) {
      let tableLine: string[] = [];
      let index: number = 0;
      empty = true;

      columns.forEach((clmn) => {
        if (clmn === "Contador") return;
        tableLine.push(" ");
        addColumnsSizeItem(index, clmn.length, 0);
        index++;
      });
    }

    // Alterar state
    if (resize) {
      this.setState({
        columnsSize: sizesList,
        list: tableGrid,
        empty,
        columns,
      });
    } else {
      this.setState({ list: tableGrid, empty, columns });
    }

    function getColumn(clmn: string, properties, isMaterial: boolean) {
      let unit = properties ? " " + properties.unit : "";
      let value = properties !== undefined ? properties.value : "";

      // Verificar se eh material
      if (value === "" && unit === "" && isMaterial) {
        value = clmn;
      }

      // Formatar se for numero
      if (value !== "" && !isNaN(Number(value))) {
        value = formatNumber(value);
      }

      return `${value}${unit}`;
    }

    function addColumnsSizeItem(
      index: number,
      columnLength: number,
      textLength: number
    ) {
      // width = se existe valor já calculado armazenado em array, pega do array.
      // senão, verifica o tamanho do valor + unidade ou da descrição da coluna (o que for maior) e calcula, então atribui no array
      if (!sizesList[index]) {
        let maxLength = Math.max(columnLength, textLength * 9) + 1;
        sizesList[index] =
          maxLength < 151 ? 151 : maxLength > 601 ? 601 : maxLength;
      }
    }
  }

  handleClickColumn = (event, column, index) => {
    const target = event.target;
    this.setState({ selectedColumnId: index });

    TakeOffStore.setSelectedColumn(column, index, target);
    WBSStore.rightMenuTab = ERightMenuTab.PROPERTIES;
    return true;
  };

  handleIsolateClick = async (e) => {
    await TakeOffStore.isolateItemsFromTakeOff();
  };

  handleCheckAll = (ev) => {
    const checked = ev.target.checked;
    TakeOffStore.checkAllTakeOffItems(checked);
  };

  handleCheckRow = (ev) => {
    let value = ev.target.value;
    let checked = ev.target.checked;
    TakeOffStore.checkSelectedItemOfTakeOff(value, checked);
  };

  headerRenderer = ({
    key, // Unique key within array of rows
    style, // Style object to be applied to row (to position it)
  }) => {
    let idx_column = 0; // indice da coluna que está sendo percorrida após tirar o campo 'contador'
    const { classes } = this.props;
    const { columns, columnsSize, selectedColumnId } = this.state;
    columnsSize[0] = 181;
    const modelMap = TakeOffStore.takeOffModelMap;
    const filters = modelMap ? modelMap.data.filters : [];
    return (
      <Table key={key} style={style} className={classes.headerContainer}>
        <TableHead className={classes.header}>
          <TableRow classes={{ root: classes.headerRoot }}>
            {columns.map((clmn, index) => {
              const columnIsSelected = selectedColumnId === index;
              const hasFilter = _.some(filters, {
                field: clmn,
              });

              const title =
                clmn.length * 7.1 > columnsSize[idx_column]
                  ? clmn.substr(0, columnsSize[idx_column] / 8) + "..."
                  : clmn;

              return (
                clmn !== "Contador" && (
                  <TableCell
                    className={classes.cellWrapper}
                    key={`header_${index}`}
                    style={{
                      textAlign: "right",
                      backgroundColor: columnIsSelected
                        ? "rgba(237, 242, 203, 1)"
                        : "",
                    }}
                    onClick={(e) => this.handleClickColumn(e, clmn, index)}
                    title={clmn.length * 6.5 >= columnsSize[idx_column] && clmn}
                  >
                    <div
                      style={{
                        width: columnsSize[idx_column++],
                        paddingRight: hasFilter || columnIsSelected ? 10 : 5,
                      }}
                    >
                      {title}
                      {hasFilter ? (
                        <img className={classes.imgFilter} src={imgFilter} />
                      ) : (
                        <img
                          className={
                            columnIsSelected
                              ? classes.imgFilterOpacity
                              : classes.imgHidden
                          }
                          src={imgFilterOutline}
                        />
                      )}
                    </div>
                  </TableCell>
                )
              );
            })}
          </TableRow>
        </TableHead>
      </Table>
    );
  };

  gridRenderer = ({ columnIndex, key, rowIndex, style }) => {
    const { classes } = this.props;
    const { list, empty, columnsSize } = this.state;
    const columnClassName = empty ? classes.columnEmpty : classes.column;

    if (list.length == 0) {
      return <div key={key} className={columnClassName}></div>;
    }

    const selectedList = TakeOffStore.listSelect;
    const cellValue = list[rowIndex][columnIndex];
    const newStyle = {
      height: style.height,
      left: style.left,
      position: style.position,
      top: style.top,
      width: style.width,
      backgroundColor: "#EDF2CB",
    };

    return (
      <div
        key={key}
        style={selectedList[rowIndex].selected ? newStyle : style}
        className={columnClassName}
      >
        {cellValue.length * 8 > columnsSize[columnIndex] ? (
          <Tooltip title={cellValue}>
            <div className={classes.cellText}>{cellValue}</div>
          </Tooltip>
        ) : (
          cellValue
        )}
      </div>
    );
  };

  rowCheckRenderer = ({ columnIndex, key, rowIndex, style }) => {
    const list = TakeOffStore.listSelect;
    const isSelected = list[rowIndex].selected;

    const newStyle = {
      ...style,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderLeft: "1px solid #e0e0e0",
      borderBottom: "1px solid #e0e0e0",
    };
    if (isSelected) newStyle.backgroundColor = "#EDF2CB";

    return (
      columnIndex === 0 && (
        <div key={key} style={newStyle}>
          <input
            type="checkbox"
            id={"lista-" + rowIndex}
            name={"lista-" + rowIndex}
            checked={isSelected}
            value={rowIndex}
            onChange={this.handleCheckRow}
          />
        </div>
      )
    );
  };

  render() {
    if (TakeOffStore.takeOffLoading) {
      return <></>;
    }

    const { classes } = this.props;
    const { list, columnsSize } = this.state;
    const TOP_HEADER = 113;

    const totalSelected = TakeOffStore.getTakeOffSelectedLength();

    return (
      <div style={{ position: "relative" }}>
        <ScrollSync>
          {({ onScroll, scrollLeft, scrollTop }) => (
            <div className={classes.container}>
              <div id="box" className={classes.box}>
                <div id="left-side" className={classes.leftSide}>
                  <div id="top-select" className={classes.topSelect}>
                    <input
                      type="checkbox"
                      name={"all"}
                      value={"all"}
                      onChange={(e) => this.handleCheckAll(e)}
                    />
                  </div>
                  <Grid
                    cellRenderer={this.rowCheckRenderer}
                    columnWidth={30}
                    rowCount={list.length}
                    rowHeight={25}
                    scrollTop={scrollTop}
                    height={window.innerHeight - (TOP_HEADER + 50 + 122)}
                    width={30}
                    columnCount={1}
                    style={{
                      backgroundColor: "#f5f5f5",
                      color: "#666",
                      fontSize: 13,
                      overflowY: "hidden",
                    }}
                  />
                </div>
                <div id="lista" className={classes.listContainer}>
                  <div id="header">
                    <List
                      scrollLeft={scrollLeft}
                      width={window.innerWidth - 290}
                      height={50}
                      rowCount={1}
                      rowHeight={50}
                      rowRenderer={this.headerRenderer}
                      style={{
                        overflowY: "hidden",
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    />
                  </div>
                  <div id="body">
                    <Grid
                      cellRenderer={this.gridRenderer}
                      style={{
                        backgroundColor: "#f5f5f5",
                        color: "#666",
                        fontSize: 13,
                      }}
                      columnCount={columnsSize.length}
                      columnWidth={({ index }) => columnsSize[index]}
                      height={window.innerHeight - (TOP_HEADER + 50 + 116)}
                      rowCount={list.length == 0 ? 1 : list.length}
                      onScroll={onScroll}
                      rowHeight={25}
                      width={window.innerWidth - 290}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </ScrollSync>
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            disabled={totalSelected == 0 ? true : false}
            className={classes.button}
            onClick={(e) => this.handleIsolateClick(e)}
          >
            <CompareBlack style={{ marginRight: 10, width: "16px" }} />{" "}
            {totalSelected == 0
              ? `${i18n.viewer.isolateFromTakeOff.isolate} ${i18n.viewer.isolateFromTakeOff.items}`
              : `${i18n.viewer.isolateFromTakeOff.isolate} ${i18n.viewer.isolateFromTakeOff.items} (${totalSelected})`}
          </Button>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(TakeOffTable);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/layouts/TakeOffTable.tsx